<template>
  <subscription-type-button
    @subscription-type-selected="(...args) => this.$emit('subscription-type-selected', ...args)"
    :selected="selected"
    :subscription-type="SUBSCRIPTION_TYPES.YEARLY"
    :main-text="'מינוי שנתי'"
    :sub-text="'חיוב אחד בשנה'"
    :extra-text="yearlyDiscountText">
    <template v-slot:price>
      <span class="ri-font-24">{{pricing.annual}}</span>
      <span class="ri-font-20">₪</span>
    </template>
    <template v-slot:sub-price>
      <div class="ri-font-14">
        <span>({{ monthlyPrice }} ₪ לחודש)</span>
      </div>
    </template>
  </subscription-type-button>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { SUBSCRIPTION_TYPES } from '@/constants/subscription-state';
import money from '@/utils/money';
import { ceil } from 'lodash';
import SubscriptionTypeButton from './SubscriptionTypeButton.vue';

export default {
  name: 'SubscriptionTypeButtonAnnual',
  components: {
    SubscriptionTypeButton,
  },
  props: {
    selected: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('subscription', ['pricing']),
    ...mapGetters('subscription', ['yearlySavingAgainstMonthlyPercentage']),
    yearlyDiscountText() {
      return `${money.formatAmountWithFraction(this.yearlySavingAgainstMonthlyPercentage, 0)}% הנחה  `;
    },
    monthlyPrice() {
      return ceil(this.pricing.annual / 12);
    },
  },
  data() {
    return {
      SUBSCRIPTION_TYPES,
      showMonthlyPriceAsPrimaryPrice: false,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
